import { APICore, API_URL, INSURANCE_URL } from './apiCore';

const api = new APICore();

const createPcInsurance = (clientId: string, creationReason?: string) => {
    return api.create(`${INSURANCE_URL}/pc-insurance`, { clientId, creationReason });
};

const editPcInsurance = (pcInsuranceId: string, body: any) => {
    const relativeUrl = `/pc-insurance/${pcInsuranceId}`;
    return api.update(`${INSURANCE_URL}${relativeUrl}`, body);
};

const getPcInsuranceStatuses = () => {
    return api.get(`${INSURANCE_URL}/pc-insurance/statuses`);
};

const getPcInsuranceStatusTrackers = (params: { pcInsuranceId?: string; clientId?: string }) => {
    const url = `${INSURANCE_URL}/pc-insurance/status-trackers`;
    return api.get(url, params);
};

export { createPcInsurance, editPcInsurance, getPcInsuranceStatuses, getPcInsuranceStatusTrackers };
